import type { IAppConfig } from "~/types/kentico/app-settings";
import api from "../auth/api";
import { useSettings } from "~/store/settings";

export default async function fetchConfig() {
	const store = useSettings();
	const { countryISOCode } = useISOCode();

	await api<IAppConfig>({
		url: `/cron/appsettings/synapse/${store.isDataFree || store.isSportsPPC ? `S${countryISOCode.value}` : countryISOCode.value}`,
		type: "config",
	}).then((res) => (store.config = res));
}
